// TermButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './TermButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * TermButton
 * 
 * Description
 *  
 *
 * @returns {ReactNode} - TermButton.
 */
const TermButton = React.memo(({ label, addonCount, isProvisioning, onClick }) => {

  // ----- CONTEXT ----- //

  // Theme Context

  const { theme } = useTheme();

  // ----- STATE ----- //

  // Hover state

  const [hovered, setHovered] = useState(false);

  // ----- RENDER ----- //

  return (

    <div
      className="term-button-container"
      style={{
        backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
      }}
      disabled={isProvisioning}
      onClick={!isProvisioning ? onClick : undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* ICON */}
      <div className="term-button-icon">
        <Icon
          iconKey="database"
          height={16}
          width={16}
          color={hovered ? theme.buttonHoverIconColor : theme.foregroundMuted}
        />
      </div>

      {/* TITLE */}
      <div
        className="term-button-title"
        style={{
          color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
        }}
      >
        {label}
      </div>

      {/* META */}
      <div
        className="term-button-meta"
        style={{
          color: hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted,
        }}
      >
        {addonCount} {addonCount === 1 ? 'addon' : 'addons'}
      </div>

            <Icon
              iconKey="chevron_right"
              width={18}
              height={18}
              color={hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted}
            />

    </div>
  );

});

// Dev Tools
TermButton.displayName = 'TermButton';

export default TermButton;
